module.exports = __webpack_public_path__ + "static/media/404.a4a258c7.png";